export const STATE_WAITING = 'STATE_WAITING'
export const STATE_TREATED = 'STATE_TREATED'
